module.exports = __webpack_public_path__ + "img/30_30.19be37f4.png";